const capitalize = (str) => {
  if (!str) {
    return '';
  }
  if (typeof str !== 'string') {
    return str;
  }
  if (str.length < 2) {
    return str.toUpperCase();
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export default capitalize;